"use strict";

require("core-js/modules/es6.object.define-property");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
/**
 * Helper: Loaders
 * -----------------------------------------------------------------------------
 * Store for loader markup
 * - https://github.com/ConnorAtherton/loaders.css
 * - https://connoratherton.com/loaders
 */

var _default = {
  ballPulse: "\n    <div class=\"loader\">\n      <div class=\"ball-pulse\">\n        <div></div>\n        <div></div>\n        <div></div>\n      </div>\n    </div>\n  "
};
exports["default"] = _default;